import type { TextProps } from '@bos/ui';
import { Text } from '@bos/ui';

export type AppBaseTextProps = TextProps;

/** Use AppText instead of AppBaseText, it should be used only within packages like mobility-ui */
export const AppBaseText = (props: AppBaseTextProps) => {
	return <Text {...props} />;
};
